import type { NetworkError } from '@apollo/client/errors'
import type { AxiosError } from 'axios'
import { GraphQLError, GraphQLFormattedError } from 'graphql'

import { LutherException } from '@acre/graphql'

export const isForbiddenError = <
  T extends 'graphql' | 'network',
  E extends T extends 'graphql' ? GraphQLFormattedError : NetworkError,
>(
  err: E,
  type: T,
) => {
  return getStatusCode(err, type) === 401
}

export const getStatusCode = <
  T extends 'graphql' | 'network',
  E extends T extends 'graphql' ? GraphQLFormattedError : NetworkError,
>(
  err: E,
  type: T,
): number | false => {
  if (type === 'graphql') {
    const { extensions, originalError } = err as GraphQLError

    if (extensions?.status) {
      const status = Number(extensions?.status)
      if (!isNaN(status) && status !== 0) return status
    }

    if (originalError) {
      if (Object.prototype.hasOwnProperty.call(originalError, 'response') && (originalError as AxiosError).response?.status) {
        const status = Number((originalError as AxiosError).response?.status)
        if (!isNaN(status) && status !== 0) return status
      }

      if ((originalError as LutherException)?.statusCode) {
        const status = Number((originalError as LutherException).statusCode)
        if (!isNaN(status) && status !== 0) return status
      }
    }
  }
  return false
}
